import "./style.css";
import { useUserInfo } from "../../../../context/user";
import { useAppServices } from "../../../../hook/services";
import { useEffect, useState } from "react";
import env from "../../../../config/env"
import axios from "axios";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import Icon from "../../../../components/icons"
import toast from "react-hot-toast";

function ApiAccess() {
  const user = useUserInfo()[0];
  const activeLocation = useUserInfo()[4];
  const UpdateUser = useUserInfo()[1];
  const saveActiveLocation = useUserInfo()[5];
  const agencyData = useUserInfo()[11]
  const AppService = useAppServices();
  const [showApiKey, setShowApiKey] = useState(false);
  const [apiKey, setApiKey] = useState(activeLocation?.apiKey);
  const [isModalOpen, setisModalOpen] = useState(false)
  const [Modalcontent, setModalcontent] = useState('')
  const [isToggled, setIsToggled] = useState(false);
  const [myResponder, setMyResponder] = useState();
  const [processing, setProcessing] = useState(false);
  const [userComment, setUserComment] = useState('');
  const [updatedByUser, setUpdatedByUser] = useState();
  const [preFixPrompt, setPreFixPrompt] = useState('');
  const [postFixPrompt, setPostFixPrompt] = useState('');
  const [defaultprompt, setdefaultprompt] = useState({});
  const contextuploadFilefrominput = useUserInfo()[16];
  const [thirdPartFiles, setThirdPartyFiles] = useState([]);
  const [selectionData, setSelectionData] = useState([]);
  const [hidebtn, setHidebtn] = useState(true);
  const userInfo = useUserInfo()[0];
  const [isCRMLoaderModal, setisCRMLoaderModal] = useState(false)


  const [assistantError, setAssistantError] = useState(false)
  const [selectedOption, setSelectedOption] = useState("");
  const [loader, setLoader] = useState(false);
  const [nangoLogin, setNangoLogin] = useState(false);

  const userActiveLocation = useUserInfo()[4];


  const BASE_URL = `${env.API_URL}/v1`

  const getsupperadminsetting = () => {
    axios.get(BASE_URL + '/super_admin_settings/').then(async function (response) {
      const fullPrompt = `${response?.data?.data?.default_prompt?.default_p1} ${response.data.data?.default_prompt?.default_p2} ${response?.data?.data?.default_prompt?.default_p3}`
      setPreFixPrompt(response?.data?.data?.default_prompt?.default_p1);
      setPostFixPrompt(response?.data?.data?.default_prompt?.default_p3);
      setUserComment(fullPrompt);
    })
      .catch(function (error) {
        console.log(error);
      });
  }
  const getaccount = async () => {
    axios.post(BASE_URL + '/accounts/checkcrmagent/', { id: activeLocation.id }).then(async function (response) {
      setApiKey(response?.data?.data?.apiKey);

    })
      .catch(function (error) {
        console.log(error);
      });
  }
  useEffect(() => {
    getaccount();
    checkSlackconnection()
  }, []);

  const getSelection = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/assistant/fetchbyuser?user_id=${userInfo._id}&location_id=${userActiveLocation?.id}`)
      if (response) {
        const initalAssistant = {
          assistant_name: "Brand AI",
          modal_name: "openai/gpt-4o",
          assistant_id: userActiveLocation?.assistant_id,
          status: true
        };

        let updatedResponse = [initalAssistant, ...response.data.data];
        let filteredResponse = updatedResponse.filter(item => item.status);
        setSelectionData(filteredResponse)
      }
    } catch (error) {
      const initalAssistant = {
        assistant_name: "Brand AI",
        modal_name: "openai/gpt-4o",
        assistant_id: userActiveLocation?.assistant_id,
        status: true
      };
      let updatedResponse = [initalAssistant];
      let filteredResponse = updatedResponse.filter(item => item.status);
      setSelectionData(filteredResponse)
      return error;
    }

  }

  useEffect(() => {
    getSelection()
  }, [])

  const checkResponder = async () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://metaconnect.maybetech.com/api/responders',
      headers: {}
    };
    await axios.request(config)
      .then((response) => {
        const exists = response.data.find(item => item.profile_id === activeLocation.id);
        if (exists) {
          setIsToggled(exists?.status)
          setMyResponder(exists);
          setUserComment(exists?.prompt)
        } else {
          setMyResponder();
          setIsToggled(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getsupperadminsetting();
    setTimeout(() => {
      checkResponder();
    }, 2000);
  }, [])


  const handleCreateApiKey = async (e) => {
    const payload = {
      profileid: activeLocation?.id,
    };

    const { response } = await AppService.user.api_key({
      payload,
      toaster: true,
    });
    if (response) {
      toast.success(<span>
        <b>API key regenerated</b>
        <br />
        <span>Your previous key has been invalidated.</span>
      </span>)
      UpdateUser(response.data);
      getaccount();
    }
  }


  const handleToggleVisibility = () => {
    setShowApiKey(!showApiKey);
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey).then(() => {
      alert("API key copied to clipboard");
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };
  const [confrirmModel, SetconfrirmModel] = useState(false);
  const [regenerateModal, setRegenerateModal] = useState(false);

  const handleConfirmRegenerate = async () => {
    setRegenerateModal(false);
    await handleCreateApiKey();
  };

  const TurnOff = () => {
    updateRespondr(false)
    setIsToggled(false);
    SetconfrirmModel(false)
  }
  const saveResponder = async () => {
    setProcessing(true);
    let promptToSave = userComment;
    if (updatedByUser) {
      promptToSave = `${preFixPrompt} ${userComment} ${postFixPrompt}`
    }
    let data = JSON.stringify({
      "profile_id": activeLocation?.id,
      "status": isToggled,
      "prompt": promptToSave,
      "prompt_custom": userComment,
      "prompt_prefix": preFixPrompt,
      "assistant_id": selectedOption?.value
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://metaconnect.maybetech.com/api/responders',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };
    try {
      let res = await axios.request(config)
        .then((response) => {
          setUserComment(response?.data?.prompt)
          setMyResponder(response?.data);
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("Error")
    }

  }

  const updateRespondr = async (status = true) => {
    setProcessing(true);
    let promptToSave = userComment;
    if (updatedByUser) {
      promptToSave = `${preFixPrompt} ${userComment} ${postFixPrompt}`
    }
    let data = {
      "profile_id": activeLocation?.id,
      "status": status,
      "prompt": promptToSave,
      "prompt_custom": userComment,
      "prompt_prefix": preFixPrompt,
      "id": myResponder?.id,
      "assistant_id": selectedOption?.value
    };
    setUserComment(userComment)
    setMyResponder(data);
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `https://metaconnect.maybetech.com/api/responders/${myResponder?.id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data)
    };
    try {
      await axios.request(config)
        .then((response) => {
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("Error")
    }

  }
  const [isConnectedCRM, setIsConnectedCRM] = useState(false);

  const fetchCRMAgentStatus = async () => {
    const response = await axios.post(
      `${BASE_URL}/accounts/checkcrmagent`, { id: activeLocation?.id }
    );
    if (response.data.status) {
      setIsConnectedCRM(true);
    } else {
      setIsConnectedCRM(false)
    }
  }
  useEffect(() => {
    fetchCRMAgentStatus();
  }, [])

  const handleConnectWithCRMAgent = (value) => {
    setisCRMLoaderModal(true)

    const payload = {
      agency_id: agencyData._id,
      api_type: "team",
      instructions: "CRM AGENT",
      model: "openai/gpt-4o",
      name: "CRM AGENT",
      profile_id: activeLocation?.id,
      readonly: true,
      status: false,
      temperature: 0.5,
      templatename: "CRM AGENT",
      top_p: 0.8,
      type: "agency",
      locationid: agencyData?.ghl?.location_id,
      handler: value
    }

    axios.post(BASE_URL + '/accounts/createcrmagent', payload).then(async function (response) {

      fetchCRMAgentStatus()
      setisCRMLoaderModal(false)


    }).catch(function (error) {
      console.log(error);
    });
  }


  const handleAssistantSelect = (selected) => {
    setSelectedOption(selected)
  }


  useEffect(() => {
    // Try to find the assistant_id match from myResponder
    const matchedAssistant = selectionData?.find(item => item?.assistant_id === myResponder?.assistant_id);

    if (matchedAssistant) {
      // If found, set the matched assistant as selected
      setSelectedOption({
        label: matchedAssistant.assistant_name,
        value: matchedAssistant.assistant_id
      });
    } else {
      // If no match, find the "Brand AI" option
      const defaultAssistant = selectionData?.find(item => item?.assistant_name === "Brand AI");
      if (defaultAssistant) {
        // If "Brand AI" is found, set it as default
        setSelectedOption({
          label: defaultAssistant.assistant_name,
          value: defaultAssistant.assistant_id
        });
      }
    }
  }, [myResponder?.assistant_id, selectionData]);
  const [isConnectedtoslack, setIsConnectedtoslack] = useState(false);
  const [assistants, setassistants] = useState([]);
  const [streamingApi, setStreamingApi] = useState(userActiveLocation?.is_streaming_Api || false);
  const [selectedAssistant, setselectedAssistant] = useState({});
  const [teamId, setTeamId] = useState('')

  const handleStreamApi = async () => {
    const updatedStream = !streamingApi;
    setStreamingApi(updatedStream);
    try {

      const response = await axios.put(`${BASE_URL}/accounts/update-streaming-api`, {
        id: userActiveLocation.id,
        streamingApi: updatedStream,
      });

      if (response.data.success) {
        saveActiveLocation(response?.data?.data)
      } else {
        console.error('Failed to update account');
      }
    } catch (error) {
      console.error('Error updating account:', error);
    }

  }



  const checkSlackconnection = async () => {
    const { response } = await AppService.accounts.checkslackconnection({ query: `profile_id=${activeLocation?.id}` })
    if (response?.data.connected == true) {
      setIsConnectedtoslack(true);
      fetchSlackconnection(response.data?.teams[0]?.teamId)
    }
  }
  const fetchSlackconnection = async (team_id) => {
    const { response } = await AppService.accounts.fetchSlackconnection({ query: `profile_id=${activeLocation?.id}&team_id=${team_id}` })
    if (response.success) {
      if (response.data.assistants)
        setassistants(response.data.assistants);
      const matchedRecord = response.data.assistants.find(
        (item) => item.assistant_id === response.data.selectedAssistantId
      );
      setTeamId(response.data.teamId)
      setselectedAssistant(matchedRecord);
    }
  }


  //agent listed in the dropdown
  const initalAssistant = {
    assistant_name: "Brand AI",
    modal_name: "openai/gpt-4o",
    assistant_id: user?.assistant_id,
    status: true
  };
  const [asistantSelected, setasistantSelected] = useState(initalAssistant)
  const [assistantData, setAssistantData] = useState([initalAssistant]);
  const Assistant = async () => {
    axios.get(`${BASE_URL}/assistant/fetchbyuser?user_id=${user._id}&location_id=${activeLocation?.id}`).then((response) => {
      let filteredResponse = response.data.data.filter(item => item.status && item.ui_enable);
      const match = filteredResponse.find(item => item.assistant_id === user.default_assistant);
      let rearrangedResponse = [];
      if (match) {
        rearrangedResponse = [
          { ...match, selected: true },
          initalAssistant,
          ...filteredResponse
            .filter(item => item.assistant_id !== user.default_assistant)
            .map(item => ({ ...item, selected: false })),
        ];
      } else {
        rearrangedResponse = [
          initalAssistant,
          ...filteredResponse.map(item => ({ ...item, selected: false })),
        ];
      }

      if (response.data?.crm_agent) {

        rearrangedResponse.push({
          assistant_name: "CRM Agent",
          modal_name: "openai/gpt-4o",
          assistant_id: response.data?.crm_agent,
          status: true
        })

      } else {
        setasistantSelected(rearrangedResponse[0]);
      }
      setAssistantData(rearrangedResponse);
    }).catch((error) => {
      let updatedResponse = [initalAssistant];
      let filteredResponse = updatedResponse.filter(item => item.status);
      setAssistantData(filteredResponse);
    })
  }
  useEffect(() => {
    Assistant()
  }, [])
  return (
    <div className="">

      {/* <div className="!border-[#D9D9D9] rounded border p-5 mb-6">
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
          <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>Enable Streaming Api</h2>
          <div style={{ padding: "10px 0" }}>
            <div
              onClick={handleStreamApi}
              className={`w-14 h-8 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer transition-colors duration-300 ${streamingApi ? 'bg-blue-500' : 'bg-gray-300'
                }`}
            >
              <div
                className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${streamingApi ? 'translate-x-6' : ''
                  }`}
              ></div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="">
        <div>
          <div className="border-b border-gray-300 pb-6 mb-6">
            <h2 className="" style={{ fontSize: "28px", fontWeight: "bold" }}>API Access</h2>
            <p className="pt-3 mb-4 text-gray-700">
              Access our API documentation to learn how to integrate with our services using this API key.
            </p>
            <a
              href="https://apidocs.maybetech.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-black hover:underline"
            >
              View Documentation →
            </a>
          </div>

          <div className="">
            <h2 className="" style={{ fontSize: "18px", fontWeight: "bold" }}>API Key</h2>
            <p className="pt-3 mb-3 text-gray-700">
              Use this API key to access our services programmatically.
            </p>
            <p className="mb-5 text-gray-700">
              This API key is shared across your entire account and may be used by active external integrations. Regenerating the key will immediately invalidate the existing key and may interrupt any services currently using it. Only regenerate this key if you are prepared to update all connected integrations.
            </p>

            <div className="!border-[#D9D9D9] rounded border p-5 flex items-center">

              <div className="flex items-center flex-1 h-[55px] pl-4 bg-[#F5F5F5] !border-[#D9D9D9] rounded border">
                <div className="flex-1 truncate" style={{ marginRight: '20px', fontWeight: 'bold' }}>
                  {showApiKey || typeof apiKey !== 'string' ? (
                    apiKey
                  ) : (
                    Array.from(apiKey).map((_, idx) => (
                      <FiberManualRecordRoundedIcon key={idx} style={{ fontSize: 'small' }} />
                    ))
                  )}
                </div>

                <button className="ms-2 py-2 text-xs text-[#757575] rounded-md uppercase font-bold" onClick={handleCopy}>
                  <Icon id={'new_copy'} />
                </button>
                <button className="px-2 ms-2 py-2 text-xs text-[#757575] rounded-md uppercase font-bold" onClick={handleToggleVisibility}>
                  {showApiKey ? <Icon id={'eyeCrossIcon'} /> : <Icon id={'eyeIcon'} />}
                </button>
              </div>

              <button
                className="px-6 ml-4 py-3 text-sm bg-black text-white rounded-md font-bold whitespace-nowrap hover:bg-gray-800"
                onClick={() => setRegenerateModal(true)}
              >
                Regenerate API Key
              </button>
            </div>
          </div>
        </div>
      </div>

      {
        regenerateModal && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50"
            onClick={() => setRegenerateModal(false)}
          >
            <div
              className="bg-white rounded-lg shadow-lg p-6 relative w-[580px] max-w-[90%]"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-xl font-bold mb-3 text-[#1e1e1e]">Regenerate API key?</h3>
              <p className="text-gray-700 mb-3">
                This will immediately invalidate your current API key.
              </p>
              <p className="text-gray-700 mb-3">
                Any integrations, scripts, or external services using the existing key will stop working until updated with the new key.
              </p>
              <p className="text-gray-700 mb-6">
                Are you sure you want to continue?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  className="px-5 py-2 text-sm font-bold  border !border-[#D9D9D9] bg-white !text-[#1e1e1e] hover:bg-gray-50"
                  onClick={() => setRegenerateModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-5 py-4 text-sm font-bold  bg-[#C00F0C] text-white hover:bg-[#B91C1C]"
                  onClick={handleConfirmRegenerate}
                >
                  Regenerate Key
                </button>
              </div>
            </div>
          </div>
        )
      }

      {

        isCRMLoaderModal &&
        <div
          className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
          onClick={() => setisCRMLoaderModal(false)}
        >
          <div
            className="bg-white rounded-lg shadow-lg p-6 relative w-96"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              className="absolute top-3 right-3 text-gray-500 cursor-pointer hover:text-gray-700"
              onClick={() => setisCRMLoaderModal(false)}
            >
              X
            </p>
            <div className="text-center">
              <p className="text-lg font-medium mb-4">It Will Take Some Time</p>
              <div className="flex items-center justify-center space-x-2 mt-4">
                <span className="w-3 h-3 bg-black rounded-full animate-pulse"></span>
                <span className="w-3 h-3 bg-black rounded-full animate-pulse delay-300"></span>
                <span className="w-3 h-3 bg-black rounded-full animate-pulse delay-600"></span>
              </div>
            </div>
          </div>
        </div>

      }

      {
        isModalOpen && (
          <div className="modal-zz" onClick={() => setisModalOpen(false)}>
            <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
              <p
                style={{
                  position: "absolute",
                  right: 0,
                  width: "12px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setisModalOpen(false)}
              >
                X
              </p>
              {Modalcontent == "no_session" ?
                <b>Something went wrong please refresh the page</b>
                :
                <iframe style={{ height: "80vh", width: "100%", overflow: 'scroll' }} src={Modalcontent}></iframe>
              }
            </div>
          </div>

        )
      }
      {
        confrirmModel &&
        <div className="modal-zz-confirm" onClick={() => SetconfrirmModel(false)}>

          <div className="scrollable-modal-content bg-white  rounded" style={{ border: "1px solid black " }}>
            <p className="modalText">
              Are you sure you want to turn off Auto-reply to Facebook and Instagram comments?
            </p>
            <div className="modalBtnGroup">
              <button className="agreeBtn" onClick={TurnOff}>
                Turn off
              </button>
              <p className="disagreeBtn" onClick={() => SetconfrirmModel(false)}>
                Cancel
              </p>
            </div>
          </div>
        </div>


      }

    </div >
  );
}
export default ApiAccess;



